/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import StringEntity from './StringEntity'
import GlobalSettings from '@/model/global/GlobalSettings'

const entity = {
  langs: {
    displayName: 'PaymentType',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'PaymentType',
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toUpperCase() === GlobalSettings.getLang().toUpperCase()
      }
    },
    childKey: 'name',
    children: [
      StringEntity, StringEntity, StringEntity
    ]
  },
  fixedDisplay: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      hint: 'fixedDisplayHint'
    }
  },
  isOnline: {
    displayName: 'isOnline',
    type: IKDataEntity.Types.Boolean
  },
  // apiKey: {
  //
  //   formConfig: {
  //     required: false,
  //     requiredNew: false,
  //     requiredEdit: false,
  //   },
  // },
  sort: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: 10
    }
  },
  displayWhenCheckout: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  }
}
const config = {
  add: function (item) {
    return hillo.post('PayMethod.php?op=add', {
      ...item,
      langs: JSON.stringify(item.langs)
    }, {
      showLoading: true
    })
  },
  edit: function (item) {
    // item.isFavorite = item.isFavorite ? 1 : 0
    return hillo.postWithUploadFile('PayMethod.php?op=update', {
      ...item,
      langs: JSON.stringify(item.langs)
    })
  },
  remove: function (id) {
    return hillo.post('PayMethod.php?op=delete', { id })
  },
  load: async function (filter) {
    return (await hillo.get('PayMethod.php', {
      showHidden: 1
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)
